import React from 'react';
import {Link} from 'react-router-dom';

export default class ShowResults extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let show = <div></div>
    let showSimilar = <div></div>
    let exact = this.props.results;
    let similar = this.props.similarResults

    if (exact.length > 0) {
      show = <div id="search-results-1" className='search-results exact-results'>
        <div className="search-result exact title">
          Exact
        </div>

        {exact.map((result, index) =>
          <div className="search-result" key={"search-exact-job-result-"+index}>
            <Link to={"/jobs/"+result.objectID}><span className="result-title">{result.title.substr(0, 25 - 1)}</span><span className="company_name">{result.company_name}</span>
              <span className="skills-ctn">
              </span>
            </Link>
          </div>
        )}
      </div>
    }

    if (similar.length > 0) {
      showSimilar = <div id="search-results-2" className='search-results similar-results'>
        <div className="search-result exact title">
          Similar
        </div>

        {similar.map((result, index) =>
          <div className="search-result" key={"search-similar-job-result-"+index}>
            <Link to={"/jobs/"+result.objectID}><span className="result-title">{result.title.substr(0, 25 - 1)}</span><span className="company_name">{result.company_name}</span>
            <span className="skills-ctn">
            </span></Link>
          </div>
        )}
      </div>
    }

    let exactAndSimilarShow = <div></div>

    if (exact.length > 0) {
      exactAndSimilarShow = <div id="exact-and-similar" className={this.props.isHidden ? "exact-and-similar hidden" : "exact-and-similar"}>
        {show}
        {showSimilar}
      </div>
    }

    return (
      <div className="all-search-results">
        {exactAndSimilarShow}
      </div>
    )
  }
}
